import React, { memo } from "react";
import {
  Stack,
  Typography,
  CardContent,
  Card,
  Button,
  Icon,
} from "investira.react.components";
import { Link } from "react-router-dom";
import utils from "../../../utils";
import { InlineInfo } from "../../../components/molecules";

const AtivoPessoa = memo((props) => {
  const { pessoa } = props;

  return (
    <Stack flexGrow={1}>
      <Card>
        <CardContent
          sx={{
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <Stack spacing={2} sx={{ py: 2 }}>
            <Stack direction="row">
              <Stack>
                <Typography
                  variant="subtitle1"
                  color="textPrimary"
                  sx={{ fontWeight: 600 }}
                >
                  Informações do Emissor
                </Typography>
              </Stack>
              <Stack flexGrow="1"></Stack>
              <Stack>
                <Button
                  component={Link}
                  title={pessoa.pessoa_fantasia}
                  endIcon={<Icon iconName="arrow-next" size={12} />}
                  size="small"
                  to={`/empresas/${pessoa.pessoa_id}`}
                  sx={{ px: 2 }}
                >
                  {`${utils.typo.shortname(pessoa.pessoa_fantasia || "", 25)}`}
                </Button>
              </Stack>
            </Stack>
            <Stack direction="column" sx={{ gap: 1 }}>
              <InlineInfo label="Razão Social" value={pessoa.pessoa} />
              <InlineInfo
                label="Nome fantasia"
                value={pessoa.pessoa_fantasia}
              />
              <InlineInfo label="CNPJ" variant="cnpj" value={pessoa.cnpj} />
              <InlineInfo label="ISIN" value={pessoa.isin} />

              <InlineInfo
                label="Setor"
                value={pessoa.setor?.top_setor}
                searchProps={{
                  path: "/empresas",
                  search: {
                    top_setor_id: pessoa.top_setor_id,
                  },
                }}
              />
              <InlineInfo
                label="Subsetor"
                value={pessoa.setor?.setor}
                searchProps={{
                  path: "/empresas",
                  search: {
                    setor_id: pessoa.setor_id,
                  },
                }}
              />
            </Stack>
          </Stack>
        </CardContent>
      </Card>
    </Stack>
  );
});

export default AtivoPessoa;
